module.exports = __webpack_public_path__ + "static/media/ReferanceInvest.9f4ccfa9.svg";